export default __webpack_public_path__ + "static/media/ppl-checkmark.3955ee2e.svg";